import { TCBReceiptApi } from "@/network/pb/proto";
import { LoginModel } from "@/models";
import Cookies from 'js-cookie';

export class Priv {
    private static priv = TCBReceiptApi.Protobuf.Permission.create();
    private static expireTime = 0;

    public static async _checkPriv(privKey?: { controller: string, method: string }) {
        const updatePermission: TCBReceiptApi.Protobuf.UserAuth = await LoginModel.updatePermission();
        console.log("####updatePermission####");
        console.log(updatePermission);
        console.log(privKey);
        console.log("####updatePermission####");

        this.expireTime = updatePermission.expireTime as number;
        
        // 無取得權限
        if (!updatePermission) {
            return false;
        }

        const groupPermission = updatePermission.groupPermission as TCBReceiptApi.Protobuf.GroupPermission;
        if (!groupPermission) {
            return false;
        }

        const userAuthPrivJson: string = JSON.stringify(groupPermission.permission) as string;
        Cookies.set("appUserAuthPrivJson", userAuthPrivJson, { sameSite: 'strict' });

        // 無對應管理權限
        if (!privKey || !groupPermission.permission[privKey.controller]) {
            return false;
        }

        const permission = groupPermission.permission[privKey.controller].map as { [k: string]: TCBReceiptApi.Protobuf.Permission };
        if (!permission || !permission[privKey.method]) {
            return false;
        }

        this.priv = permission[privKey.method];

        return true;
    }

    public static _getPriv() {
        return this.priv;
    }

    public static _checkPrivType(type: string): boolean {
        const priv = this.priv;

        let isSet = false;
        switch(type) {
          case "get":
            isSet = (priv.get === 1) ? true : false;
            break;
          case "add":
            isSet = (priv.add === 1) ? true : false;
            break;
          case "edit":
            isSet = (priv.edit === 1) ? true : false;
            break;
          case "delete":
            isSet = (priv.delete === 1) ? true : false;
            break;
          case "release":
            isSet = (priv.release === 1) ? true : false;
            break;

          default:
            console.log("Permission Error");
            break;
        }

        return isSet;
    }

    public static _getExpireTime(): number {
      return this.expireTime;
    }
}
